import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { ShipperUser } from 'src/pages/shipper-admin/details/types';
import { NoContent } from 'src/utils/no-content';

export function useFutureShipperUser(id: string) {
  const futureShipperUser = useAxios(
    (axios, signal) =>
      // if the user was deactivated (or will be deactivated to the next gas day)
      // the response is just "204 No Content"
      axios.request<ShipperUser | NoContent>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shipperUsers/futureShipperUser/${id}`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    futureShipperUser.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return futureShipperUser;
}

export type FutureShipperUserRequest = ReturnType<typeof useFutureShipperUser>;
